module.exports = __webpack_public_path__ + "img/Business_item_4.c242ee3d.jpg";